import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'sm-youtube-embed-video',
  templateUrl: './youtube-embed-video.component.html',
  styleUrls: ['./youtube-embed-video.component.scss']
})
export class YoutubeEmbedVideoComponent implements OnInit {
  safeUrl: SafeResourceUrl;
  constructor(@Inject(MAT_DIALOG_DATA) public parentdata:any,private sanitizer: DomSanitizer) { 

    this.safeUrl = this.sanitizeUrl(this.parentdata.link);
  }

  ngOnInit(): void {
  }

  sanitizeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
